import React from 'react';
import { useNavigate } from 'react-router-dom';

function Navbar() {
    const navigate = useNavigate();

    function handleAdminClick() {
        navigate('/admin');
    }

    function handleHomeClick() {
        navigate('/home');
    }

    function handleLogoClick() {
        navigate('/');
        window.location.reload();

    }

    return (
        <div id='head'>
            <div onClick={handleLogoClick}>
                <h1>Arun Excello</h1>
            </div>
            <div id='options'>
                {sessionStorage.getItem("isAdmin") ? (
                    <span onClick={handleHomeClick}> Admin </span>

                ) : (
                    <span onClick={handleAdminClick}> Login</span>

                )}
            </div>
        </div>
    );
}

export default Navbar;
